import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchCancellationPolicy } from './../../SeatLayout/redux/thunks';
import { REVIEW_PAGE } from './../../../config/messages';
import dateformat from 'dateformat';

const ThankyouTravellerInfo = props => {
    const dispatch = useDispatch();
    const { thankyouInfo, bookingStatus, setPopupContent } = props;
    const { txnid = '', update_obj = {}, passengers, bookingList } = thankyouInfo;
    const { bid, tripKey = '' } = update_obj;
    const isLoaded = bookingStatus && (bookingStatus.toLowerCase() == 'confirmed' || bookingStatus.toLowerCase() == 'cancel' || bookingStatus.toLowerCase() == 'processing') ? true : false;
    const { seatno, src, des, depDate, busName, busType, arrTime, boardAt, depTime } = bookingList[0];
    const deptDate = function () {
        let d = '';
        if (depDate) {
            d = dateformat(new Date(depDate), 'mmm. dd, yyyy');
        }
        return d;
    }()
    
    return (
        <>

            <div className="centerBox">
                <div id="ajaxLoader11" className={`ticketBox marginT20 ${isLoaded ? '' : 'opaPartial'}`}>
                    <div className="col-md-12 col-sm-12 col-xs-12  ">
                        <div className="width100 fl borderBtm dib">
                            <i className="icon-bus  greyDr ico32 fl mobdn padR10"></i>
                            <div className="fl padT5">
                                <span className="greyDr fb ico16 fl padT3 padR10">
                                    {src} to {des}</span>
                                <span className="greyLt ico14 fl padT5 padB10">
                                    {deptDate}</span>
                            </div>
                            <div className="fareRlz">
                                <span style={{ color: '#166bd3', cursor: 'pointer' }} id="cpolicythankyoupage" className="" onClick={() => {
                                    // will check and add vid
                                    const res = dispatch(fetchCancellationPolicy(bid, "", "", tripKey));
                                    res
                                        .then(r => {
                                            if (r.data && r.data.error) {
                                                setPopupContent({ title: 'Cancellation Policy', content: `<div>${REVIEW_PAGE.CANCELLATION_POLICY_ERROR}</div>` });

                                            } else {
                                                setPopupContent({ title: 'Cancellation Policy', content: r.data });

                                            }
                                        })
                                        .catch(err => {
                                            setPopupContent({ title: 'Cancellation Policy', content: `<div>${REVIEW_PAGE.CANCELLATION_POLICY_ERROR}</div>` });
                                            console.log(err);
                                        });


                                }}>* Cancellation Policy </span>
                            </div>
                        </div>
                    </div>
                    <div className="ticketCenter">
                        <div className="col-md-12 col-sm-12 col-xs-12 padT20">
                            <div className="col-md-10 col-sm-10 col-xs-12 tcktHead ">
                                <span className="airlineSprite jetIcon padL20"></span>
                                <span className="fl white">
                                    <span className="fl width100 ico19">{busName}</span>
                                    <span className="ico12 fl padT3">{busType}</span>
                                </span>
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="col-md-10 col-sm-10 col-xs-12 tcktbody pad15">
                                <div className="col-md-5 col-sm-5 col-xs-12 pad0">
                                    <div className="width100 fl padTB5">
                                        <span className="greyLt ico12 fl width100 lh1-5">Travel Date</span>
                                        <span className="grey ico16 fl width100">{deptDate}</span>
                                    </div>
                                </div>
                                <div className="col-md-7 col-sm-7 col-xs-12 pad0">
                                    <div className="width100 fl padT5">
                                        <span className="width100 fl greyLt ico12 padB2 padT3">Booking Id</span>
                                        <span className="width100 fl ico15 grey">{txnid}
                                        </span>
                                    </div>
                                </div>

                                <div className="width100 fl padT15">
                                    <div className="flghtInfo">
                                        <span className="grey ico14 fl width100 lh1-5">
                                            {src}
                                        </span>
                                        <span className="grey ico20 fl">
                                            {depTime}</span>

                                    </div>
                                    <div className="flghtInfo padT10 dib txtCenter padL15">
                                        <i className="icon-flight_line2 ico18 greyLt fl dib"></i>
                                        <i className="icon-bus ico16 fl greyLt dib padT1"></i>
                                    </div>
                                    <div className="flghtInfo">
                                        <span className="grey ico14 fl width100 lh1-5">
                                            {des}</span>
                                        <span className="grey ico20 fl">{arrTime}</span>
                                    </div>
                                    <div className="width100 fl padT20 padB10">
                                        <div className="col-md-10 col-sm-10 col-xs-12">
                                            <span className="width100 fl greyLt ico12 lh1-5">Boarding Point</span>

                                            <span className="fl grey ico14">
                                                {boardAt}
                                            </span>
                                        </div>
                                        <div className="col-md-2 col-xs-12 col-sm-2 padT10">
                                            {seatno.map((seat, index) => {
                                                return (<span key={seat + index} style={{ marginLeft: +index ? '2px' : '0px' }} className="statusTag green">{seat}</span>)

                                            })}

                                        </div>
                                    </div>
                                    <div className="width100 fl padTB10">
                                        <span className="width100 fl greyLt ico12 lh1-5">Passenger(s)</span>

                                        <span className="fl grey ico16">
                                            {passengers.map((obj, index) => {
                                                const { Title, FirstName, LastName } = obj;

                                                let title_map = {
                                                    '1': 'Mr',
                                                    '2': 'Mrs',
                                                    '3': 'Miss',
                                                    '4': 'Master',
                                                    '5': 'Miss'
                                                }
                                                let title = title_map[Title];
                                                return (
                                                    <span key={title + FirstName + LastName + index} className="fl width100 padT3">
                                                        {title ? title : ''} {FirstName} {LastName}


                                                    </span>
                                                )

                                            })}

                                        </span>
                                        <span className="statusTag green fr marginR15">
                                            <i className="gsfl" id={`busstatus1`}>
                                                {isLoaded ? bookingStatus : "InProgress"}
                                            </i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ThankyouTravellerInfo;
